const packageJson = require('../../package.json');
// from env
export const DEBUG = process.env.REACT_APP_DEBUG;
export let GS_URL = process.env.REACT_APP_GAMESERVER_URL;
export let MS_URL = process.env.REACT_APP_MASTERSERVER_URL;
export let LOBBY_ZERO_API_URL = process.env.REACT_APP_LOBBY_ZERO_API_URL;
export let LOBBY_ZERO_SOCKET_PATH = process.env.REACT_APP_LOBBY_ZERO_SOCKET_PATH;
export let CT_SOCKET_PATH = process.env.REACT_APP_CT_SOCKET_PATH;
export let MTT_SOCKET_PATH_LOBBY = process.env.REACT_APP_MTT_SOCKET_PATH_LOBBY;
export let MTT_SOCKET_PATH_TABLE = process.env.REACT_APP_MTT_SOCKET_PATH_TABLE;
export let USER_COOKIE_NAME = process.env.REACT_APP_USER_COOKIE_NAME;
export let USER_COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;
export let APP_VENDOR = process.env.REACT_APP_VENDOR;
export let LOBBY_ZERO_OPEN_API_URL = process.env.REACT_APP_LOBBY_ZERO_OPEN_API_URL;
export let VENDOR_NAME = process.env.REACT_APP_VENDOR_NAME.replaceAll('_', ' ');
export let APP_BASE_PATH = process.env.REACT_APP_BASE_PATH ? process.env.REACT_APP_BASE_PATH : "";
export let VENDOR_REDIRECT_URL = process.env.REACT_APP_VENDOR_REDIRECT_URL;
export let CASHIER_URL = process.env.REACT_APP_CASHIER_URL;
export let PROFILE_URL = process.env.REACT_APP_PROFILE_URL;
export let WALLET_URL = process.env.REACT_APP_WALLET_URL
export const USER_BALANCES_URL_2 = "/get_balance";
export const S3_LINK_THEME = process.env.REACT_APP_S3_LINK_THEME;
export const S3_LINK_ASSETS = process.env.REACT_APP_S3_LINK_ASSETS;
export const APP_VERSION = packageJson.version;
export let PokerTheme = {};
export let AssetsMap = {};
// others
export let LOGIN_URL = VENDOR_REDIRECT_URL;
export let VERIFY_TOKEN_URL = MS_URL+"/verifyToken";

export let CASH_TABLE_URL = MS_URL + "/poker/cashtables";
export let MS_API_URL = MS_URL+"/apis/v1";
export let VENDOR_CONFIG = "";
export const LOCATION_TAKEN_TIME = "location"

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV;


export function setEnvValue(envVals, config) {
    VENDOR_CONFIG = config
    GS_URL = envVals.REACT_APP_GAMESERVER_URL;
    MS_URL = envVals.REACT_APP_MASTERSERVER_URL;
    LOBBY_ZERO_API_URL = envVals.REACT_APP_LOBBY_ZERO_API_URL;
    LOBBY_ZERO_SOCKET_PATH = envVals.REACT_APP_LOBBY_ZERO_SOCKET_PATH;
    CT_SOCKET_PATH = envVals.REACT_APP_CT_SOCKET_PATH;
    MTT_SOCKET_PATH_LOBBY = envVals.REACT_APP_MTT_SOCKET_PATH_LOBBY;
    MTT_SOCKET_PATH_TABLE = envVals.REACT_APP_MTT_SOCKET_PATH_TABLE;
    USER_COOKIE_NAME = envVals.REACT_APP_USER_COOKIE_NAME;
    LOBBY_ZERO_OPEN_API_URL = envVals.REACT_APP_LOBBY_ZERO_OPEN_API_URL
    APP_VENDOR = envVals.REACT_APP_VENDOR
    USER_COOKIE_DOMAIN = envVals.REACT_APP_COOKIE_DOMAIN;
    MS_API_URL = MS_URL+"/apis/v1";
    LOGIN_URL = VENDOR_REDIRECT_URL;
    VERIFY_TOKEN_URL = MS_URL+"/verifyToken";
    CASH_TABLE_URL = MS_URL + "/poker/cashtables"; 
    PokerTheme = config.pokerThemeMap;
    AssetsMap = config.assetsMap;
}

export const AUTH_STATE = {
    'STARTED': 'started',
    'IN_PROGRESS': 'in_progress',
    'COMPLETE': 'complete'
};

export const gameTypeInfo = {
    "pot_limit_omaha": {
        "display_name": "PL Omaha",
        "short_display_name": "PLO",
        "priority": 2
    },
    "texas_holdem": {
        "display_name": "NL Holdem",
        "short_display_name": "NLHE",
        "priority": 1
    },
    "pot_limit_omaha_5": {
        "display_name": "PLO 5",
        "short_display_name": "PLO5",
        "priority": 3
    },
    "pot_limit_omaha_6": {
        "display_name": "PLO 6",
        "short_display_name": "PLO6",
        "priority": 3
    }

};

export const gameTypeMap = {
    "pot_limit_omaha": {
        "typestring": "plo",
        "tabs_display_name": "Omaha",
        "short_name_small": "plo",
        "short_name_full": "PLO",
        "proper_name": "Pot Limit Omaha",
        "priority": 2
    },
    "texas_holdem": {
        "typestring": "nl-holdem",
        "tabs_display_name": "NL Holdem",
        "short_name_small": "nlh",
        "short_name_full": "NLH",
        "proper_name": "No Limit Holdem",
        "priority": 1
    },
    "pot_limit_omaha_5": {
        "typestring": "pl05",
        "tabs_display_name": "Omaha 5",
        "short_name_small": "plo5",
        "short_name_full": "PLO5",
        "proper_name": "Pot Limit Omaha 5",
        "priority": 3
    }
};

export function getErrorMessageFromCode(errorCode) {
    switch (errorCode) {
        case "Error : CT001" :
            return "Missing Parameters"; // ErrorMessageBadRequest
        case "Error : CT002" :
            return "Invalid Request"; // ErrorMessageCommandNotAvailable
        case "Error : CT003" :
            return "Player already seated on the network"; // ErrorMessageAlreadyInCtFromOtherDomain
        case "Error : CT004" :
            return "Seat already reserved";  // ErrorMessageAlreadyReservedSeat
        case "Error : CT005" :
            return "Invalid Seat"; // ErrorMessageSeatNotFound
        case "Error : CT006" :
            return "Player already seated"; // ErrorMessageAlreadySitting
        case "Error : CT007" :
            return "Player is not allowed to take seat";  // ErrorMessageBannedPlayer
        case "Error : CT008" :
            return "Wallet Error";  // ErrorMessageWalletError
        case "Error : CT009" :
            return "Someone from same IP address is already seated"; // ErrorMessageIPConflict
        case "Error : CT010" :
            return "Timer Expired"; // ErrorMessageTimerExpired
        case "Error : CT011" :
            return  "Player is not on table"; // ErrorMessagePlayerNotInTable
        case "Error : CT012" :
            return "Topup failed because stack is more than max buy in"; // ErrorMessageStackMoreThanMaxBuyIn
        case "Error : CT013" :
            return "Insufficient balance in Real cash wallet"; // ErrorMessageInsufficientFund
        case "Error : CT014" :
            return "Topup is in progress"; // ErrorMessagePreviousTopUpIsPending
        case "Error : CT015" :
            return  "Player is not sitting out"; // ErrorMessagePlayerIsNotSittingOut
        case "Error : CT016" :
            return "ErrorMessageReBuyWithoutRequest"; // ErrorMessageReBuyWithoutRequest
        case "Error : CT017" :
            return "Player already in waiting queue"; // ErrorMessageAlreadyInWaitingQueue
        case "Error : CT022" :
            return "Leave table is in progress"; // ErrorMessageLeaveTableInProgress
        case "Error : CT026" :
            return "Player is not in waiting list"; // ErrorMessagePlayerNotInWaitQueue
        case "Error : CT027":
            return "Seating in progress"; // ErrorMessageSeatingInProgress
        case "Error : CT028":
            return "Rebuy request in progress"; //ErrorMessagePlayerReBuyRequestInProgress
        case "Error : CT029":
            return "Rebuy in progress";
        case "Error : CT030":
            return "Player reserve is in progress"; // ErrorMessagePlayerReserveInProgress
        case "Error : CT031":
            return "System upgrade in progress"; // ErrorMessageSystemUpgrade
        case "Error : TT001" :
            return "Missing Parameters"; // ErrorMessageBadRequest
        case "Error : TT002" :
            return "Invalid Request"; // ErrorMessageCommandNotAvailable
        case "Error : TT003" :
            return "Player is already registered"; // ErrorMessageUserAlreadyRegistered
        case "Error : TT004" :
            return "No more entries allowed"; // ErrorMessageRegistrationMaxLimitReached
        case "Error : TT005" :
            return "No more re-retries allowed"; // ErrorMessagePlayerRegisterationMaxLimitReached
        case "Error : TT006" :
            return "Currently not registering"; // ErrorMessageNotInRegistrationState
        case "Error : TT007" :
            return "Player not registered"; // ErrorMessageNotRegistered
        case "Error : TT013" :
            return "Player is already registered on the network"; // ErrorMessageUserInMttFromOtherDomain
        case "Error : TT015":
            return "Rebuy failed because stack is more than min allowed"; // ErrorMessageStackMoreThanMinAllowed
        case "Error : TT016":
            return "Rebuy limit reached"; // ErrorMessageReBuyLimitExceeded
        case "Error : TT017" :
            return "Rebuy time is over";//ErrorMessageReBuyTimeIsOver
        case "Error : TT018" :
            return "Rebuy is not Allowed"; //ErrorMessageReBuyIsNotAllowed
        case "Error : TT019" :
            return "No seat found"; //ErrorMessageSeatNotFound
        case "Error : TT020" :
            return "Player is not seated"; //ErrorMessagePlayerNotSeated
        case "Error : TT021" :
            return "Stack is not zero"; //ErrorMessageStackIsNonZero
        case "Error : TT022" :
            return "Hand is Running"; //ErrorMessageHandIsRunning
        case "Error : TT023" :
            return "Add on already done";//ErrorMessageAddOnAlreadyDone
        case "Error : TT024" :
            return "Add on is not allowed"; //ErrorMessageAddOnNotAllowed
        case "Error : TT025" :
            return "Player already sitting out"; //ErrorMessageAlreadySittingOut
        case "Error : TT026" :
            return "Player is not seated!"; //ErrorMessageEmptySeat
        case "Error : TT027" :
            return "Wallet Error!!"; //ErrorMessageWalletError
        case "Error : TT028" :
            return "Insufficient funds"; //ErrorMessageInsufficientFund
        case "Error : TT029" :
            return "Invalid ticket"; //ErrorMessageTicketNotValid
        case "Error : TT039" :
            return "You entered this tournament post winning satellite, unregistering is not allowed"; //ErrorMessageSatelliteWinnerCannotUnRegister
        case "Error : H008" :
            return "Please enter valid Table PIN"; //PvtTableUnlockInvalidPin
        case "Error : H010" :
            return "This table has expired"; //PvtTableUnlockTableExpired
        case "Error : H005":
            return "No more tables are available in this room to join"; // ErrorMessageofNoTables
        default:
            return "Something went wrong - code: " + errorCode;
    }
}

export const MTTFilters = {
    "buy_in" : [
        {
            id : "All",
            checked : true,
            key : "all"
        },
        {
            id : "Micro(₹ 0 - 100)",   
            checked : true,
            key : "micro"  
        },
        {
            id : "Low(₹ 101 - 1000)",
            checked : true,
            key : "low"
        },
        {
            id : "Mid(₹ 1001 - 2500)",
            checked : true,
            key : "mid"
        },
        {
            id : "High(₹ 2501 +)",
            checked : true,
            key : "high"
        }
    ],
    "speed" : [
        {
            id : "All",
            checked : true,
            key : "all"
        },
        {
            id : "Regular",
            checked : true,
            key : "regular"
        },
        {
            id : "Turbo",
            checked : true,
            key : "turbo"
        },
        {
            id : "Hyper-Turbo",
            checked : true,
            key : "hyper_turbo"
        },
        {
            id : "Slow",
            checked : true,
            key : "slow"
        }
    ],
    "variants" : [
        {
            id : "All",
            checked : true,
            key : "all"
        },
        {
            id: "Re-buy",
            checked : true,
            key: "re_buy"
        },
        {
            id : "Re-Entry",
            checked : true,
            key : "re_entry"
        },
        {
            id : "Re-Buy + Add-On",
            checked : true,
            key : "re_buy_add_on"
        },
        {
            id: "Regular",
            checked : true,
            key : "regular",
        },
        {
            id : "Freeroll",
            checked : true,
            key : "freeroll"
        },
        {
            id : "Satellite",
            checked : true,
            key : "satellite"
        },
    ],
    "status" : [
        {
            id : "All",
            checked : true,
            key : "all"
        },
        {
            id : "Registered",
            checked : true,
            key : "registered"
        },
        {
            id : "Register",
            checked : true,
            key : "registering"
        },
        {
            id : "Running",
            checked : true,
            key : "running"
        },
        {
            id : "Late Registeration",
            checked : true,
            key : "late_registration"
        },
        {
            id : "Upcoming",
            checked : true,
            key : "upcoming"
        }
    ],
    "date" : [
        {
            id : "Today",
            checked : false,
            key : "today"
        },
        {
            id : "Tomorrow",
            checked : false,
            key : "tomorrow"
        }
    ]
}

export const cashgameFilter = {
    "players" : [
        {
            id : "All",
            checked : true,
            key : "all"
        },
        {
            id : "7-9 Players",
            checked : true,
            key : [7,8,9]
        },
        {
            id : "3-6 Players",
            checked : true,
            key : [3,4,5,6]
        },{
            id : "2 Players(Heads-Up)",
            checked : true,
            key : [2]
        }
    ],
    "stakes" : [
        {
            id : "All",
            checked : true,
            key : "all"
        },
        {
            id : "Nano ( ₹ 0.1 - 1 )",
            checked : true,
            key : "nano"
        },
        {
            id : "Micro ( ₹ 1 - 2 )",
            checked : true,
            key : "micro"
        },
        {
            id : "Low ( ₹ 2 - 20 )",
            checked : true,
            key : "low"
        },
        {
            id : "Mid ( ₹ 20 - 100 )",
            checked  : true,
            key : "mid"
        },
        {
            id : "High ( >₹ 100 )",
            checked : true,
            key : "high"
        }
    ],
    "tableType" : [
        {
            id : "All",
            checked : true,
            key : "all"
        },
        {
            id : "Run It Twice",
            checked : true,
            key : "rit"
        },
        {
            id : "All-in Cover",
            checked : true,
            key : "ev"
        }
    ]
}


export function getStakeType(bigBlind) {
    let stake = "";
    if (bigBlind>=0 && bigBlind < 1) {
        stake = "nano";
    }else if (bigBlind >=1 && bigBlind <= 2) {
        stake = "micro";
    } else if (bigBlind > 2 && bigBlind <= 20) {
        stake = "low";
    } else if (bigBlind > 20 && bigBlind <= 100) {
        stake = "mid";
    } else if (bigBlind > 100) {
        stake = "high";
    }
    return stake;
}

export function getTourneyStakeStype(buyIn) {
    let stake = "";
    if ((buyIn >= 0 && buyIn <= 100) || !buyIn) {
        stake = "micro";
    } else if (buyIn > 100 && buyIn <=1000) {
        stake = "low";
    } else if (buyIn > 1000 && buyIn <= 2500) {
        stake = "mid";
    } else if(buyIn) {
        stake = "high";
    }
    return stake;
}

export const seatUserMap = {
    "9" : 5,
    "8" : 4,
    "7" : 5,
    "6" : 3,
    "5" : 3,
    "4" : 2,
    "3" : 2,
    "2" : 1
}
